import React from 'react';
import {withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import * as R from 'ramda';

import {
  Intro,
  UpcomingCompetitions,
  NewsPart,
  Sponsors,
} from './index';

import './MainPage.scss';


class MainPage extends React.Component {

  render() {

    return (
      <React.Fragment>
        <Intro/>
        <hr style={{borderTop: '1px solid #FFFFFF', marginTop: '45px'}}/>
        <UpcomingCompetitions/>
        <hr style={{borderTop: '1px solid #FFFFFF', marginTop: '45px'}}/>
        <NewsPart/>
        <hr style={{borderTop: '1px solid #FFFFFF', marginTop: '45px'}}/>
        <Sponsors/>
      </React.Fragment>
    );
  }
}

function applyContext(WrappedComponent) {
  const injectContext = R.pipe(
    observer,
    inject('stores'),
    withRouter
  );
  return injectContext(WrappedComponent);
}

export default applyContext(MainPage);
